import * as React from 'react'
import Transactions from '../components/transaction'
import { useQueryParam, StringParam } from 'use-query-params'
import Layout from '../components/layout'

const BchWallet = typeof window !== 'undefined' ? window.SlpWallet : null
const options = { interface: 'consumer-api', noUpdate: true }

const TransactionsPage = (props) => {
  const [txid] = useQueryParam('txid', StringParam)

  let bchjs
  if (BchWallet) {
    const wallet = new BchWallet(null, options)
    bchjs = wallet.bchjs
    console.log('bchjs', bchjs)
  }
  return (
    <Layout {...props}>
      <Transactions bchjs={bchjs} txid={txid} />
    </Layout>
  )
}

export default TransactionsPage
